import { StatisticGraph } from "../../../../../../shared/components/statistic/StatisticGraph"
import { fetchPosSalesWithPeriodInDays, MerchantHomeQuery } from "../../merchantHomeApi"
import { useMerchant } from "../../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { toDinero, toNumberLossy } from "../../../../../currency/currencyLib"
import { useMoney } from "../../../../../currency/useMoney"
import { useEffect } from "react"

type StatisticsPosSalesProps = Readonly<{
    periodInDays: number
    setCurrencyPosSales: (val: string) => void
}>

export function StatisticsPosSales({ periodInDays, setCurrencyPosSales }: StatisticsPosSalesProps) {
    const { merchantId } = useMerchant()
    const moneyFactory = useMoney({})

    const { data } = useApiQuery(fetchPosSalesWithPeriodInDays, {
        queryName: MerchantHomeQuery.STATISTICS_POS_SALES,
        dependencies: {
            merchantId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })
    if (!data) return null

    useEffect(() => {
        setCurrencyPosSales(data?.reportSummary?.totalAmount?.currency || "")
    }, [data])

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.posSales.map((entry) => entry.date)}
            datasets={data.posSales.map((entry) => toNumberLossy(toDinero(entry.salesSummary.totalAmount)))}
            title={moneyFactory.formatCompact(toDinero(data?.reportSummary?.totalAmount))}
        />
    )
}
